export default __webpack_public_path__ + "7a101498562288ab3dbdf7749696cac0.svg";